export const numberOfLables = ({ verticals, qty }) => {
  return (
    verticals
      .flatMap(({ glass }) => glass.map(({ qty }) => qty))
      .reduce((acc, curr) => acc + curr, 0) * qty
  );
};
